import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

export const deviceService = {
  getDevices: async (params: {
    page?: number;
    limit?: number;
    name?: string;
    org_name?: string;
  }) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/device`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  },

  getDeletedDevices: async (params: {
    page?: number;
    limit?: number;
    name?: string;
    org_name?: string;
  }) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/device/deleted`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  },

  getDeviceById: async (id: number) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/device/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  createDevice: async (data: {
    device_name: string;
    device_image: string;
    device_description: string | null;
    device_diagram: string | null;
    org_id: string;
  }) => {
    const token = localStorage.getItem("token");

    const response = await axios.post(`${API_BASE_URL}/device`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  updateDevice: async (
    id: number,
    data: {
      device_name: string;
      device_description: string | null;
      device_image: string;
      device_diagram: string | null;
      org_id: string;
    },
  ) => {
    const token = localStorage.getItem("token");

    const response = await axios.put(`${API_BASE_URL}/device/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  deleteDevice: async (id: number) => {
    const token = localStorage.getItem("token");

    const response = await axios.delete(`${API_BASE_URL}/device/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  restoreDevice: async (id: number) => {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_BASE_URL}/device/restore/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  },

  transferDevice: async (deviceId: number, organizationId: string) => {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_BASE_URL}/device/${deviceId}/transfer`,
      { organizationId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  },

  // ฟังก์ชันใหม่สำหรับการอัปเดตระยะเวลาการเข้าถึงข้อมูล
  updateDataAccessTime: async (
    deviceId: number,
    data: { start_time?: string | Date; end_time?: string | Date | null }
  ) => {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${API_BASE_URL}/device/${deviceId}/access-time`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }
};